import { fromUTCISOStringToLondon } from '../../../helpers/date'
import { TableBooleanField, TableSelectField, TableTextField } from './Fields'
import { completingFors, lastTimeExperiencedSymptoms, travelToDestinations, typeOfCovidTests } from './index'
import { friendlyConstant } from './RecoveryCertificate'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const CertificateData = ({
  recoveryCertificate,
  edit,
}: {
  recoveryCertificate: RecoveryCertificateQuery_recoveryCertificates
  edit: boolean
}) => {
  if (!recoveryCertificate?.orderId) {
    return <p>Loading...</p>
  }

  return (
    <article className="message">
      <div className="message-header">
        <p className="has-text-light">Certificate Data</p>
      </div>
      <div className="message-body p-0">
        <table className="table is-fullwidth is-striped is-size-7 has-valign-middle">
          <tbody>
            <TableSelectField
              label="Completing For"
              value={recoveryCertificate?.completingFor}
              name="completingFor"
              options={completingFors.map((status) => ({
                label: friendlyConstant(status),
                value: status,
              }))}
              edit={edit}
            />
            <TableTextField
              label="Completing For - First Name"
              value={recoveryCertificate?.completingForFirstName}
              name="completingForFirstName"
              edit={edit}
            />
            <TableTextField
              label="Completing For - Last Name"
              value={recoveryCertificate?.completingForLastName}
              name="completingForLastName"
              edit={edit}
            />
            <TableTextField
              label="Completing For - Relationship to Patient"
              value={recoveryCertificate?.completingForRelationshipToPatient}
              name="completingForRelationshipToPatient"
              edit={edit}
            />
            <TableTextField label="First Name" value={recoveryCertificate?.firstName} name="firstName" edit={edit} />
            <TableTextField label="Last Name" value={recoveryCertificate?.lastName} name="lastName" edit={edit} />
            <TableTextField
              label="Date of Birth"
              value={recoveryCertificate?.dateOfBirth && fromUTCISOStringToLondon(recoveryCertificate?.dateOfBirth)}
              name="dateOfBirth"
              type="date"
              edit={edit}
            />
            <TableTextField
              label="Email Address"
              value={recoveryCertificate?.emailAddress}
              name="emailAddress"
              edit={edit}
            />
            <TableTextField
              label="Telephone Number"
              value={recoveryCertificate?.telephoneNumber}
              name="telephoneNumber"
              edit={edit}
            />
            <TableTextField
              label="Passport Number"
              value={recoveryCertificate?.passportNumber}
              name="passportNumber"
              edit={edit}
            />
            <TableSelectField
              label="Travel to Destination"
              value={recoveryCertificate?.travelToDestination}
              name="travelToDestination"
              options={travelToDestinations.map((status) => ({
                label: friendlyConstant(status),
                value: status,
              }))}
              edit={edit}
            />
            <TableTextField
              label="Travel to Destination - Description"
              value={recoveryCertificate?.travelToDestinationOtherDescription}
              name="travelToDestinationOtherDescription"
              edit={edit}
            />
            <TableTextField
              label="Positive Covid Test Date"
              value={
                recoveryCertificate?.positiveCovidTestDate &&
                fromUTCISOStringToLondon(recoveryCertificate?.positiveCovidTestDate)
              }
              name="positiveCovidTestDate"
              type="date"
              edit={edit}
            />
            <TableSelectField
              label="Type of Covid Test"
              value={recoveryCertificate?.typeOfCovidTest}
              name="typeOfCovidTest"
              options={typeOfCovidTests.map((status) => ({
                label: friendlyConstant(status),
                value: status,
              }))}
              edit={edit}
            />
            <TableTextField
              label="Type of Covid Test Description"
              value={recoveryCertificate?.typeOfCovidTestDescription}
              name="typeOfCovidTestDescription"
              edit={edit}
            />
            <TableBooleanField
              label="Covid Symptoms Around Test Date"
              value={recoveryCertificate?.covidSymptomsAroundTestDate}
              name="covidSymptomsAroundTestDate"
              edit={edit}
            />
            <TableSelectField
              label="Last time experienced symptoms"
              value={recoveryCertificate?.lastTimeExperiencedSymptoms}
              name="lastTimeExperiencedSymptoms"
              options={lastTimeExperiencedSymptoms.map((status) => ({
                label: friendlyConstant(status),
                value: status,
              }))}
              edit={edit}
            />
            <TableTextField
              label="Additional Information"
              value={recoveryCertificate?.additionalInformation}
              name="additionalInformation"
              type="textarea"
              edit={edit}
            />
          </tbody>
        </table>
      </div>
    </article>
  )
}
